module.exports = __webpack_public_path__ + "static/media/avatar.7c8e5f50.png";